import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITochiChicken } from "@snackpass/snackpass-types";
import { StoreState } from ".";

export const getChicken = (state: StoreState) => state.tochiChicken.chicken;

export type TochiChickenReduxType = { chicken: ITochiChicken | null };

const tochiChickenSlice = createSlice({
  name: "tochiChicken",
  initialState: {
    chicken: null,
  } as TochiChickenReduxType,
  reducers: {
    setChicken: (
      state: TochiChickenReduxType,
      action: PayloadAction<ITochiChicken | null>
    ) => {
      state.chicken = action.payload;
      return state;
    },
  },
});

export const { setChicken } = tochiChickenSlice.actions;
export const tochiChickenReducer = tochiChickenSlice.reducer;
